import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="w-full px-4 py-20 md:px-6 md:py-28">
      <div className="mx-auto max-w-xl text-center">
        <p className="font-heading text-6xl font-black text-primary-200 md:text-8xl">404</p>
        <h1 className="mt-4 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
          这条内容暂时找不到了
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600">
          页面可能已经被归档更新，或者链接输入有误。你可以回到首页，或直接去汇总清单和归档中心继续浏览。
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-semibold text-primary-50 transition-colors hover:bg-primary-700"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/summary"
            className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-semibold text-foreground-900 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            <i className="ri-list-check-2"></i>
            浏览汇总清单
          </Link>
        </div>
      </div>
    </section>
  );
}